import { render, staticRenderFns } from "./driver_bid_board_tbn.vue?vue&type=template&id=8f4ed2f0&scoped=true&"
import script from "./driver_bid_board_tbn.vue?vue&type=script&lang=js&"
export * from "./driver_bid_board_tbn.vue?vue&type=script&lang=js&"
import style0 from "./driver_bid_board_tbn.vue?vue&type=style&index=0&id=8f4ed2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4ed2f0",
  null
  
)

export default component.exports